// src/utils/sentryUtils.js
import * as Sentry from "@sentry/react";

export const logInfo = (message, data = {}) => {
  Sentry.addBreadcrumb({
    category: "info",
    message,
    data,
    level: "info",
  });
};

export const captureError = (error, context = {}) => {
  Sentry.withScope((scope) => {
    scope.setExtras(context);
    Sentry.captureException(error);
  });
};

// Hier stond captureMessage. Dat maakt van elke geslaagde aanroep een eigen melding bij Sentry -- en er
// wordt er honderd keer een verstuurd, met namen als "fetchCombinations.success". Het gevolg: een keer
// een widget openen leverde zes tot acht meldingen op, onze eigen foutentabel stond vol met gelukte
// aanroepen, en een echte fout viel daar niet meer tussen op te merken. Bovendien kost elke melding een
// plek in wat Sentry per maand toestaat.
//
// Het is nu een kruimel: hij reist mee met een fout als die er komt, en bij een geslaagde ronde gaat er
// niets de deur uit. Precies wat je wilt weten als er wel iets misgaat: wat er vlak daarvoor gebeurde.
// De honderd aanroepen in de widgets blijven staan zoals ze zijn. (W11, 17-09-2026)
export const captureEvent = (eventName, data = {}) => {
  Sentry.addBreadcrumb({
    category: "gebeurtenis",
    message: eventName,
    data,
    level: "info",
  });
};

// Hier stond een setUser die het e-mailadres en de naam van de gast aan Sentry meegaf. Dat werd
// door niemand aangeroepen, en het hoort ook niet: een gast die een tafel reserveert is geen
// gebruiker van een systeem waar je fouten aan koppelt. Weg gelaten in plaats van gerepareerd, want
// een functie die er staat wordt vroeg of laat gebruikt. (WI7, 13-09-2026)

/**
 * Wraps an async operation in a Sentry span for performance tracing.
 * Usage: const result = await withSpan("widget.load", () => fetchWidgetData(key));
 */
export const withSpan = async (name, operation, attributes = {}) => {
  return Sentry.startSpan({ name, attributes }, () => operation());
};

/**
 * Records a user action breadcrumb (button clicks, form submits, navigation steps).
 */
export const logUserAction = (action, data = {}) => {
  Sentry.addBreadcrumb({
    category: "user.action",
    message: action,
    data,
    level: "info",
  });
};

/**
 * Records a navigation breadcrumb for widget step changes.
 */
export const logNavigation = (from, to, data = {}) => {
  Sentry.addBreadcrumb({
    category: "navigation",
    message: `${from} → ${to}`,
    data,
    level: "info",
  });
};